const errorCodes = {
    internal: {
        UNKNOWN: '2-0-0',
        OTHER: '2-10-1',
        LOCKED_UPDATE: '0-11-10',

        AUTHENTICATION_ERROR: '2-11-1',
        AUTHORIZATION_ERROR: '2-11-2',

        REQUEST_VALIDATION_ERROR: '2-12-1',
        CAPTCHA_VALIDATION_ERROR: '2-12-2',
        ACCOUNT_SUSPENDED: '2-12-3',
        ACCOUNT_EXISTS: '2-12-4',
        ACCOUNT_NOT_EXISTS: '2-12-5',
        ACTIVATION_DATA_NOT_EXISTS: '2-12-6',
        PASSWORD_INPUTS_DO_NOT_MATCH: '2-12-7',
        PREVIOUS_PASSWORDS_VALIDATION: '2-12-8',
        BAD_CREDENTIALS: '2-12-9',
        INVALID_RESET_PASSWORD_TOKEN_ERROR: '2-12-10',
        INVALID_WEB_AUTH_PARAMETERS_ERROR: '29-12-11',
        WRONG_DIGIT_CODE: '2-12-12',
        INCORRECT_DIGIT_CODE: '2-12-13',
        DOMAIN_EXISTS: '2-12-14',
        VPN_SETTING_RESTRICT_OPERATION: '2-12-15',
        DEVICE_LIMIT_EXCEEDED: '2-12-16',
        RESET_PASSWORD_DATA_NOT_FOUND: '2-12-17',
        EMAIL_RESEND_NOT_ALLOWED_YET: '2-12-18',
        AUTH_INVALID_PASSWORD_VALUE: '2-12-19',
        INVALID_MFA_SETUP_TOKEN_ERROR: '2-12-20',
        INVALID_MFA_CODE_ERROR: '2-12-21',
        PROFILE_NOT_READY: '2-12-22',
        DOMAIN_NOT_EXISTS: '2-12-23',
        INVALID_TOKEN_TYPE: '2-12-24',
        DEFAULT_GROUP_NOT_FOUND: '2-12-25',
        GROUP_NOT_FOUND: '2-12-26',
        GROUP_MAPPING_NOT_FOUND: '2-12-27',
        SAML_CONFIGURATION_NOT_FOUND: '2-12-28',
        DOMAIN_AUTH_CONFIG_NOT_VALID: '2-12-29',
        TRUSTED_DEVICES_NOT_ALLOWED: '2-12-30',
        WEB_AUTH_INVALID_NODE_ID: '2-12-34',
        WEB_AUTH_INVALID_SSO_ID: '2-12-35',

        ACCOUNT_CREATION_FAIL: '2-14-1',

        SUBNET_EXHAUSTED: '2-15-1',
        ID_GENERATION_FAIL: '2-15-2',
        CONFIGURATION_INCORRECT: '2-15-3',

        GENERIC_INTEGRATION_ERROR: '2-3-0',
        X_VERIFY_ERROR: '2-3-1',
        CERT_PROFILE_ERROR: '2-3-2',
        BILLING_ERROR: '2-3-3',
        SSO_GENERAL_ERROR: '2-3-4',
        CF_TEMPLATE_PARSE_ERROR: '2-3-5',
        BUNDLE_ERROR: '2-3-6',
        NOTIFICATION_ERROR: '2-3-7',
        SCRIPT_ERROR: '2-3-8',
        AZURE_TEMPLATE_ERROR: '2-3-9',
        LDAP_UNREACHABLE: '2-3-10',
        LDAP_CERT_ERROR: '2-3-11',
        EGRESS_TEMPLATE_ERROR: '2-3-12',
        EMAIL_ERROR: '7-12-1',

        SSO_REQUEST_VALIDATION_ERROR: '3-12-1',
        SSO_CAPTCHA_VALIDATION_ERROR: '3-12-2',
    },
    networks: {
        UNKNOWN: '9-0-0',
        OTHER: '9-10-1',
        REQUEST_VALIDATION_ERROR: '9-11-1',
        GENERATION_IN_PROGRESS: '9-11-2',
        ID_GENERATION_FAIL: '9-12-1',
        REMOVE_LAST_CONNECTOR: '9-11-59',
        GENERIC_INTEGRATION_ERROR: '9-13-0',
        CF_TEMPLATE_ERROR: '9-13-1',
        BUNDLE_ERROR: '9-13-2',
        SCRIPT_ERROR: '9-13-3',
        AZURE_TEMPLATE_ERROR: '9-13-4',
        EGRESS_TEMPLATE_ERROR: '9-13-5',
    },
    networkManagement: {
        PROFILE_NOT_READY: '31-12-22',
    },
    settings: {
        UNKNOWN: '10-0-0',
        OTHER: '10-10-1',
        REQUEST_VALIDATION_ERROR: '10-11-1',
        GENERIC_INTEGRATION_ERROR: '10-13-0',
    },
    region: {
        UNKNOWN: '11-0-0',
        OTHER: '11-10-1',
        REQUEST_VALIDATION_ERROR: '11-11-1',
        GENERIC_INTEGRATION_ERROR: '11-13-0',
    },
    access: {
        UNKNOWN: '12-0-0',
        OTHER: '12-10-1',
        REQUEST_VALIDATION_ERROR: '12-11-1',
        LIMIT_REACHED: '12-11-13',
        ID_GENERATION_FAIL: '12-12-1',
        GENERIC_INTEGRATION_ERROR: '12-13-0',
    },
    cloudProps: {
        UNKNOWN: '13-0-0',
        OTHER: '13-10-1',
        REQUEST_VALIDATION_ERROR: '13-11-1',
        GENERIC_INTEGRATION_ERROR: '13-13-0',
    },
    ipAssignment: {
        UNKNOWN: '14-0-0',
        OTHER: '14-10-1',
        REQUEST_VALIDATION_ERROR: '14-11-1',
        SUBNET_EXHAUSTED: '14-11-7',
        IP_ALLOCATION_FAIL: '14-12-1',
        IP_GENERATION_IN_PROGRESS: '14-12-2',
        GENERIC_INTEGRATION_ERROR: '14-13-0',
    },
    userprops: {
        REQUEST_VALIDATION_ERROR: '15-11-1',
        USERPROP_RULE_NOT_FOUND_ERROR: '15-11-2',
        GENERIC_INTEGRATION_ERROR: '15-12-0',
        IO: '15-12-1',
        AWS_ERROR: '15-13-2',
    },
    certProfile: {
        UNKNOWN: '16-0-0',
        OTHER: '16-10-1',
        REQUEST_VALIDATION_ERROR: '16-11-1',
        GENERIC_INTEGRATION_ERROR: '16-13-0',
    },
    cloudConsumer: {
        UNKNOWN: '17-0-0',
        OTHER: '17-10-1',
        REQUEST_VALIDATION_ERROR: '17-11-1',
        GENERIC_INTEGRATION_ERROR: '17-13-0',
    },
    profile: {
        UNKNOWN: '18-0-0',
        OTHER: '18-10-1',
        REQUEST_VALIDATION_ERROR: '18-11-1',
        BUNDLING_ERROR: '18-11-2',
        BUNDLING_IN_PROGRESS_ERROR: '18-11-3',
        GENERIC_INTEGRATION_ERROR: '18-13-0',
    },
    notification: {
        UNKNOWN: '19-0-0',
        OTHER: '19-10-1',
        REQUEST_VALIDATION_ERROR: '19-11-1',
        GENERIC_INTEGRATION_ERROR: '19-12-0',
    },
    ipGeo: {
        UNKNOWN: '20-0-0',
        OTHER: '20-10-1',
        REQUEST_VALIDATION_ERROR: '20-11-1',
        GENERIC_INTEGRATION_ERROR: '20-12-0',
    },
    userManagement: {
        REQUEST_VALIDATION_ERROR: '21-11-1',
        OPERATION_RESTRICTED: '21-11-5',
        DEVICE_LIMIT_EXCEEDED: '21-11-6',
        INVITATION_FAILED: '21-11-14',
        PROFILE_DISTRIBUTION: '21-11-18',
        OWNER_OPERATION_FAILED: '21-11-40',
        DEVICE_ENFORCEMENT_LEVEL_2: '21-11-48',
        RESTRICTED_DEVICE_NOT_FOUND: '21-11-45',
        PROFILE_NOT_READY: '29-12-22',
        WEB_AUTH_INVALID_NODE_ID: '29-12-34',
        WEB_AUTH_INVALID_SSO_ID: '29-12-35',
    },
    pgApi: {
        INVALID_WEB_AUTH_PARAMETERS_ERROR: '34-11-2',
        WEB_AUTH_INVALID_NODE_ID: '34-11-4',
        WEB_AUTH_INVALID_SSO_ID: '34-11-3',
    },
} as const;

const legacyCodesMapping = {
    [errorCodes.internal.INVALID_WEB_AUTH_PARAMETERS_ERROR]: [
        errorCodes.pgApi.INVALID_WEB_AUTH_PARAMETERS_ERROR,
    ],
    [errorCodes.internal.WEB_AUTH_INVALID_NODE_ID]: [
        errorCodes.pgApi.WEB_AUTH_INVALID_NODE_ID,
        errorCodes.userManagement.WEB_AUTH_INVALID_NODE_ID,
    ],
    [errorCodes.internal.WEB_AUTH_INVALID_SSO_ID]: [
        errorCodes.pgApi.WEB_AUTH_INVALID_SSO_ID,
        errorCodes.userManagement.WEB_AUTH_INVALID_SSO_ID,
    ],
    [errorCodes.internal.CAPTCHA_VALIDATION_ERROR]: [
        errorCodes.internal.SSO_CAPTCHA_VALIDATION_ERROR,
    ],
    [errorCodes.internal.PROFILE_NOT_READY]: [
        errorCodes.profile.BUNDLING_IN_PROGRESS_ERROR,
        errorCodes.networks.GENERATION_IN_PROGRESS,
        errorCodes.networkManagement.PROFILE_NOT_READY,
        errorCodes.userManagement.PROFILE_NOT_READY,
    ],
    [errorCodes.internal.REQUEST_VALIDATION_ERROR]: [
        errorCodes.internal.REQUEST_VALIDATION_ERROR,
        errorCodes.networks.REQUEST_VALIDATION_ERROR,
        errorCodes.settings.REQUEST_VALIDATION_ERROR,
        errorCodes.region.REQUEST_VALIDATION_ERROR,
        errorCodes.access.REQUEST_VALIDATION_ERROR,
        errorCodes.cloudProps.REQUEST_VALIDATION_ERROR,
        errorCodes.ipAssignment.REQUEST_VALIDATION_ERROR,
        errorCodes.ipAssignment.SUBNET_EXHAUSTED,
        errorCodes.userprops.REQUEST_VALIDATION_ERROR,
        errorCodes.certProfile.REQUEST_VALIDATION_ERROR,
        errorCodes.cloudConsumer.REQUEST_VALIDATION_ERROR,
        errorCodes.profile.REQUEST_VALIDATION_ERROR,
        errorCodes.notification.REQUEST_VALIDATION_ERROR,
        errorCodes.ipGeo.REQUEST_VALIDATION_ERROR,
        errorCodes.userManagement.REQUEST_VALIDATION_ERROR,
        errorCodes.userManagement.OPERATION_RESTRICTED,
        errorCodes.userManagement.DEVICE_LIMIT_EXCEEDED,
    ],
    [errorCodes.internal.SUBNET_EXHAUSTED]: [errorCodes.ipAssignment.IP_ALLOCATION_FAIL],
} as const;

const legacyCodesMap = new Map<string, string>();
for (const [legacyCode, newCodeList] of Object.entries(legacyCodesMapping)) {
    for (const newCode of newCodeList) {
        legacyCodesMap.set(newCode, legacyCode);
    }
}

function mapToLegacyErrorCode<T>(code: T): T extends string ? string : T;

function mapToLegacyErrorCode<T>(code: T) {
    if (typeof code !== 'string') {
        return code;
    }

    if (code.startsWith('7-')) {
        return errorCodes.internal.EMAIL_ERROR;
    }

    return legacyCodesMap.get(code) ?? code;
}

export { errorCodes, mapToLegacyErrorCode };
